import { UserModel } from "./user-model";
import { MenuModel } from "./menu-model";

export class ZeroPaperModel {
  user: UserModel = new UserModel();
  menu: MenuModel[] = [];    
}



// WEBPACK FOOTER //
// ./src/app/shared/models/zero-paper-model.ts